import { cache, } from "./cache";
import { wagmiConfig as config, } from "@wagmiconfig";
import * as B from "@bracket/contractor-next/brktETH";



export const totalValue = async (): Promise<bigint> => {

	const now = Date.now();
	const { time, value, since, } = cache.total_value;
	if(since > now - time) {
		return value;
	}

	const next = await B.getTotalValue({ config, });

	cache.total_value.since = Date.now();
  cache.total_value.value = next;

	return next;
}
